var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoEssentia21AnosEsp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_essentia_21_anos_BR",
    xmlns: "http://www.w3.org/2000/svg",
    width: 425.2,
    height: 425.2,
    viewBox: "0 0 425.2 425.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1",
    "data-name": "Ret\\xE2ngulo 1",
    width: 425.2,
    height: 425.2,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19",
    "data-name": "Grupo 19",
    transform: "translate(4.062 -44.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14",
    "data-name": "Grupo 14",
    transform: "translate(89.717 255.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_77",
    "data-name": "Caminho 77",
    d: "M147.614,789.988a8.573,8.573,0,0,1,12.334,1.9,7.811,7.811,0,0,1,.981,8.256l-3.073-1.576a4.632,4.632,0,0,0-.479-4.771,5.575,5.575,0,0,0-8.924,6.638,4.589,4.589,0,0,0,4.431,1.83l.648,3.38a7.861,7.861,0,0,1-7.645-3.3,8.575,8.575,0,0,1,1.725-12.36Z",
    transform: "translate(-144.01 -708.784)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_78",
    "data-name": "Caminho 78",
    d: "M187.431,853.979l-5.451-5.25-2.8,1.365-2.855-2.749L192.8,839.69l3.254,3.135L189,859.553l-2.835-2.729,1.259-2.845Zm-2.59-6.829,4.044,3.892,3.377-7.536-7.421,3.641Z",
    transform: "translate(-165.652 -743.281)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_79",
    "data-name": "Caminho 79",
    d: "M243.083,872.253l2.94,2.085-7.966,11.227,5.841,4.143-1.837,2.587-8.782-6.231,9.8-13.814Z",
    transform: "translate(-203.786 -765.084)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_80",
    "data-name": "Caminho 80",
    d: "M289.787,900.97l3.152,1.748-8.217,14.812-3.152-1.748Z",
    transform: "translate(-236.121 -784.315)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81",
    "data-name": "Caminho 81",
    d: "M322.381,916.51l6.208,2.465c4.933,1.959,7.11,6.456,5.227,11.2s-6.542,6.5-11.478,4.543l-6.208-2.465Zm1.13,15.261a5.07,5.07,0,0,0,6.882-2.954,4.958,4.958,0,0,0-2.974-6.892l-2.858-1.133-3.909,9.842,2.858,1.133Z",
    transform: "translate(-259.263 -794.721)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82",
    "data-name": "Caminho 82",
    d: "M390.968,956.447l-7.391-1.625-1.669,2.623-3.869-.849,10.034-15.135,4.414.971,2.739,17.944-3.842-.846Zm-5.779-4.467,5.481,1.2L389.61,945Z",
    transform: "translate(-300.718 -811.427)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_83",
    "data-name": "Caminho 83",
    d: "M454.633,950.3l6.671.317c5.3.251,8.822,3.8,8.577,8.9s-4.08,8.273-9.38,8.022l-6.671-.317Zm6.02,14.065a5.07,5.07,0,0,0,5.551-5.025,4.958,4.958,0,0,0-5.052-5.554l-3.069-.146-.5,10.579,3.069.145Z",
    transform: "translate(-351.468 -817.347)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84",
    "data-name": "Caminho 84",
    d: "M572.843,954.793l1.523,1.15-2.022,2.544-1.655-1.279a9.514,9.514,0,0,1-3.763,1.7,8.762,8.762,0,1,1,6.8-10.444,8.741,8.741,0,0,1-.889,6.327Zm-4.923.317-2.366-1.8,2.025-2.518,2.366,1.8a6.032,6.032,0,0,0,.158-3.334c-.674-3.1-3.165-5.005-6.218-4.341s-4.507,3.423-3.832,6.525c.667,3.076,3.142,5.009,6.195,4.348a5.033,5.033,0,0,0,1.672-.674Z",
    transform: "translate(-420.016 -811.489)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85",
    "data-name": "Caminho 85",
    d: "M620.97,920.119l3.387-1.384,3.806,9.307c.9,2.187,2.709,3.2,5.151,2.2,2.4-.981,2.98-2.974,2.088-5.161l-3.806-9.307,3.387-1.384,3.846,9.4c1.6,3.9.449,7.47-4.3,9.413-4.8,1.959-8.124.195-9.7-3.661l-3.856-9.426Z",
    transform: "translate(-463.386 -793.301)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_86",
    "data-name": "Caminho 86",
    d: "M681.79,891.928l10.232-6.248,1.616,2.643-7.153,4.368,1.92,3.142,7-4.275,1.616,2.643-7,4.275,2.052,3.36,7.153-4.368,1.629,2.666-10.232,6.248-8.828-14.458Z",
    transform: "translate(-504.111 -774.077)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_87",
    "data-name": "Caminho 87",
    d: "M765.673,846.749a7.413,7.413,0,0,0,5.432-2.171c1.408-1.394,1.431-2.742.75-3.426-.9-.9-2.243-.172-3.955.882-2.412,1.5-5.471,3.463-8.138.776-1.986-2-1.863-5.339.965-8.148a9.411,9.411,0,0,1,6.35-2.974l.436,3.287a7.228,7.228,0,0,0-4.748,2.1c-1.153,1.143-1.265,2.257-.552,2.98.806.813,2.065.063,3.773-.991,2.432-1.517,5.544-3.426,8.19-.757,2.181,2.2,2.26,5.412-.985,8.633a9.766,9.766,0,0,1-7,3.152l-.525-3.344Z",
    transform: "translate(-555.421 -737.925)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_88",
    "data-name": "Caminho 88",
    d: "M792.82,792.841l7.176-9.6,2.481,1.853-5.019,6.71,2.95,2.2,4.913-6.568,2.481,1.854-4.913,6.568,3.152,2.356,5.019-6.714,2.5,1.87-7.176,9.6L792.82,792.831Z",
    transform: "translate(-578.458 -705.482)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_89",
    "data-name": "Caminho 89",
    d: "M838.45,710.813l1.616-3.783,13.827.8-10.146-9.413,1.616-3.783,13.014,12.654L856.6,711.44l-18.152-.624Z",
    transform: "translate(-609.012 -646.148)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_90",
    "data-name": "Caminho 90",
    d: "M863.56,671.769l.988-3.469,16.292,4.642-.988,3.469Z",
    transform: "translate(-625.826 -628.518)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_91",
    "data-name": "Caminho 91",
    d: "M871.323,617.449l.618-4.067,13.586-2.686-12.175-6.578.618-4.067,15.763,9-.681,4.47-17.732,3.932Z",
    transform: "translate(-631.022 -582.817)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_92",
    "data-name": "Caminho 92",
    d: "M879.626,559.969l-.066-11.986,3.1-.017.046,8.379,3.681-.02-.043-8.2,3.1-.017.043,8.2,3.935-.02-.046-8.379,3.122-.016.066,11.987-16.936.092Z",
    transform: "translate(-636.539 -547.89)",
    fill: "#b1965e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16",
    transform: "translate(164.373 110.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15",
    transform: "translate(101.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_93",
    "data-name": "Caminho 93",
    d: "M768.566,228.806l21.73-21.73L772.29,189.09l-7.236,7.236-3.737-3.737,7.246-7.242-7.246-7.245,3.737-3.737,7.252,7.252,10.754-10.751L772.3,160.1l-7.246,7.242-3.727-3.727,10.979-10.979L789.067,169.4V191.36l-9.512-9.512-3.509,3.509,17.987,18V167.347L772.3,145.617,754.31,163.623l7.236,7.236-3.737,3.737-7.245-7.246-7.242,7.246-3.737-3.737,7.252-7.252-10.751-10.754-10.761,10.761,7.246,7.246-3.727,3.727-10.979-10.979,16.761-16.761h21.958l-9.512,9.512,3.509,3.509,18-17.987H732.57l-21.73,21.737L728.847,181.6l7.235-7.236,3.737,3.737-7.245,7.245,7.245,7.246-3.737,3.737-7.252-7.252-10.754,10.751,10.761,10.761,7.242-7.242,3.727,3.727-10.979,10.979-16.761-16.761V179.337l9.512,9.512,3.509-3.509-17.987-18V203.35l21.737,21.73,17.987-18.006-7.236-7.236,3.737-3.737,7.242,7.246,7.245-7.246,3.737,3.737L754.3,207.09l10.751,10.754,10.761-10.761-7.246-7.246,3.727-3.727,10.979,10.979-16.761,16.761H744.55l9.512-9.512-3.509-3.509-17.99,17.983h36Zm3.733-61.684,3.743,3.743-3.737,3.737-3.743-3.743Zm-39.954-3.509,3.743-3.743,3.737,3.737-3.743,3.743Zm-3.509,39.954-3.743-3.743,3.737-3.737,3.743,3.743Zm21.73-29.2L754.3,178.1l-3.737,3.737L746.83,178.1Zm-7.242,14.716-3.737-3.737,3.737-3.737,3.737,3.737Zm7.242,7.242-3.737-3.737,3.737-3.737,3.737,3.737Zm3.509-10.979,3.737-3.737,3.737,3.737-3.737,3.737Zm14.716,21.733-3.744,3.743-3.737-3.737,3.743-3.743Z",
    transform: "translate(-696.861 -131.638)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94",
    "data-name": "Caminho 94",
    d: "M783.521,142.34l-31.46-31.46H707.57l-31.46,31.46v44.491l31.46,31.46h44.491l31.46-31.46Zm-4.962,42.436-28.553,28.553H709.628l-28.552-28.553V144.4l28.552-28.553h40.377L778.558,144.4v40.377Z",
    transform: "translate(-676.11 -110.88)",
    fill: "#b1965e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95",
    "data-name": "Caminho 95",
    d: "M415.72,390.682c-4.318-3.307-9.984-4.982-16.837-4.982a31.591,31.591,0,0,0-13.3,2.65,22.763,22.763,0,0,0-8.742,6.618,12.765,12.765,0,0,0-2.983,7.655,4.977,4.977,0,0,0,1.361,3.651,4.455,4.455,0,0,0,3.36,1.391,4.4,4.4,0,0,0,3.406-1.378,4.651,4.651,0,0,0,1.312-3.307,6.224,6.224,0,0,0-1.55-4.493l-.4-.426.228-.538a13.826,13.826,0,0,1,5.924-6.482,17.856,17.856,0,0,1,9.238-2.5c5.554,0,9.565,1.857,11.924,5.518,2.283,3.552,3.314,8.2,3.069,13.83-.168,3.869-1.8,8.2-4.863,12.866a72.063,72.063,0,0,1-11.8,13.536l-.01.01-.01.01-4.183,3.565c-4.735,4.08-8.491,7.559-11.167,10.335a39.434,39.434,0,0,0-6.717,9.525,29.683,29.683,0,0,0-3.01,11.23h49.846l1.49-14.6h-1.88c-.327,3.188-1.609,5.389-3.819,6.548-2.26,1.189-5.58,1.768-10.153,1.768-3.119,0-5.584-.04-7.328-.119l-20.772-.595-1.1-.033.258-1.074c.826-3.463,3.03-7.133,6.548-10.916a111.374,111.374,0,0,1,14.213-12.4c15.555-11.97,23.719-22.5,24.257-31.295.38-7.09-1.573-12.33-5.8-15.568Z",
    transform: "translate(-369.97 -294.901)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_96",
    "data-name": "Caminho 96",
    d: "M578.486,466.051l.238-1.137a57.587,57.587,0,0,0,.7-8.048l3.654-71.177h-2.825l-22.4,16.447,1.255,2.081,13.8-8.663.218-.139h1.437l-.043.938-2.63,56.071c-.165,4.513-1.15,8.019-2.924,10.411-1.711,2.306-4.47,3.628-8.214,3.935l-.066,2.181h27.849l.155-3.39-9.053.429-1.16.056Z",
    transform: "translate(-495.776 -294.895)",
    fill: "#b3965f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17",
    transform: "translate(168.846 296.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_97",
    "data-name": "Caminho 97",
    d: "M404.126,693.867l-3.767,14.114c-.238,1.031-.317,1.784.357,1.784.833,0,2.339-2.22,3.092-3.727l1.229.833c-1.507,3.053-3.687,5.907-7.1,5.907-2.3,0-3.172-1.546-2.26-4.6l.952-3.211h-.079c-2.022,3.608-5.075,7.81-9.357,7.81-2.815,0-3.687-2.181-3.687-4.639,0-4.916,4.123-14.59,13-14.59a5.621,5.621,0,0,1,2.775.674l.079-.357h4.758Zm-7.335,1.507c-4.559,0-7.89,8.524-7.89,12.41,0,1.308.278,1.982,1.15,1.982,2.458,0,6.74-7.85,7.771-10.943.4-1.11.714-2.1.912-2.855A2.915,2.915,0,0,0,396.792,695.374Z",
    transform: "translate(-383.51 -686.215)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_98",
    "data-name": "Caminho 98",
    d: "M454.19,697.871,458,682.963c.277-.991.2-1.586-.555-1.665l-2.3-.2.317-1.308,8.405-1.07.2.2L461.6,686.73h.119c2.418-4.322,5.789-8.048,9.634-8.048,3.132,0,3.727,2.538,2.815,5.471l-2.775,8.921c-.317,1.031-.4,1.745.238,1.745.912,0,2.537-2.22,3.33-3.727l1.229.952c-1.467,3.053-3.925,5.868-7.454,5.868-2.22,0-3.251-1.625-2.418-4.361l2.894-9.555c.357-1.189.317-2.3-.674-2.3-2.062,0-5.709,5.63-6.78,8.247a62.407,62.407,0,0,0-2.656,7.493ZM474.807,672.1c-.555,1.388-1.982,4.084-4.52,4.084a8.752,8.752,0,0,1-2.736-.714,8.026,8.026,0,0,0-2.7-.714,3.173,3.173,0,0,0-2.617,1.824l-1.348-.793c.595-1.506,2.22-4.123,4.52-4.123a10.043,10.043,0,0,1,2.855.714,8.076,8.076,0,0,0,2.815.753c1.11,0,1.784-.753,2.418-1.784l1.308.753Z",
    transform: "translate(-430.838 -671.35)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_99",
    "data-name": "Caminho 99",
    d: "M545.971,700.647a13.754,13.754,0,0,1-1.943,7.216c-1.7,2.855-4.639,4.916-9.4,4.916-5.273,0-7.612-2.934-7.612-6.938,0-5.907,4.084-12.291,11.379-12.291C542.007,693.55,545.971,695.017,545.971,700.647Zm-13.837,7.292c0,1.9.872,2.974,2.5,2.974,4.123,0,6.225-9.714,6.225-12.41,0-1.546-.476-3.053-2.379-3.053C534.275,695.45,532.134,704.767,532.134,707.939Z",
    transform: "translate(-479.605 -686.215)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_100",
    "data-name": "Caminho 100",
    d: "M604.4,696.96a2.417,2.417,0,0,1-2.339,2.141,1.519,1.519,0,0,1-1.467-.991c-.991-1.863-1.665-2.736-2.775-2.736a1.67,1.67,0,0,0-1.7,1.863c0,1.07.833,2.062,3.013,3.925,2.062,1.744,3.528,3.092,3.528,5.551,0,3.291-2.775,6.066-7.493,6.066s-6.225-2.1-6.225-3.767a2.649,2.649,0,0,1,2.379-2.537,1.471,1.471,0,0,1,1.546.991c1.229,2.537,2.26,3.489,3.449,3.489a1.832,1.832,0,0,0,1.9-1.982c0-1.269-1.07-2.656-2.855-4.163-1.467-1.269-3.33-2.775-3.33-5.313,0-3.37,2.537-5.947,6.938-5.947S604.4,695.77,604.4,696.96Z",
    transform: "translate(-521.067 -686.215)",
    fill: "#b3965f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18",
    "data-name": "Grupo 18",
    transform: "translate(62.929 118.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_101",
    "data-name": "Caminho 101",
    d: "M70.855,644.521,68.39,632.792l3.033-.638,1.721,8.2,3.6-.757-1.685-8.029,3.033-.638,1.685,8.029,3.852-.81-1.721-8.2,3.056-.641,2.465,11.729-16.576,3.482Z",
    transform: "translate(-66.586 -465.931)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_102",
    "data-name": "Caminho 102",
    d: "M75.3,584.086a7.419,7.419,0,0,0,1.956-5.511c-.119-1.979-1.117-2.884-2.078-2.825-1.269.076-1.609,1.573-1.949,3.552-.466,2.8-1.014,6.4-4.791,6.624-2.815.172-5.243-2.124-5.485-6.106a9.419,9.419,0,0,1,1.959-6.733l2.759,1.844a7.23,7.23,0,0,0-1.559,4.956c.1,1.622.859,2.442,1.873,2.382,1.14-.069,1.411-1.51,1.748-3.489.466-2.828,1.087-6.426,4.84-6.654,3.092-.188,5.561,1.877,5.835,6.443a9.774,9.774,0,0,1-2.253,7.338L75.3,584.1Z",
    transform: "translate(-62.929 -427.632)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_103",
    "data-name": "Caminho 103",
    d: "M75.345,523.856A7.439,7.439,0,0,0,78.1,518.7c.175-1.973-.677-3.017-1.639-3.1-1.265-.112-1.824,1.318-2.452,3.225-.876,2.7-1.949,6.175-5.716,5.841-2.808-.248-4.87-2.878-4.52-6.849a9.421,9.421,0,0,1,2.934-6.37l2.455,2.23a7.232,7.232,0,0,0-2.273,4.668c-.142,1.619.489,2.541,1.5,2.63,1.14.1,1.619-1.285,2.247-3.192.879-2.726,2.025-6.195,5.769-5.864,3.086.274,5.22,2.679,4.817,7.232a9.766,9.766,0,0,1-3.314,6.922l-2.557-2.214Z",
    transform: "translate(-63.467 -387.004)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_104",
    "data-name": "Caminho 104",
    d: "M70.91,460.523l2.8-11.653,3.013.724-1.959,8.147,3.581.862,1.916-7.976,3.013.724-1.916,7.976,3.826.919,1.959-8.147,3.036.73-2.8,11.653Z",
    transform: "translate(-68.273 -345.107)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_105",
    "data-name": "Caminho 105",
    d: "M94.155,393.163l10.493,4.4-1.394,3.327L87.63,394.342l1.434-3.42,13.15-3-10.12-4.239,1.394-3.327,15.624,6.545-1.345,3.208-13.615,3.053Z",
    transform: "translate(-79.469 -299.232)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_106",
    "data-name": "Caminho 106",
    d: "M122.763,331.634l-2.617,4.2-2.7-1.678,7.14-11.468,2.7,1.678-2.6,4.183,11.686,7.275-1.92,3.083-11.686-7.272Z",
    transform: "translate(-99.437 -260.616)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_107",
    "data-name": "Caminho 107",
    d: "M154.05,297.262l2.243-2.822,13.255,10.546-2.243,2.822Z",
    transform: "translate(-123.944 -241.699)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_108",
    "data-name": "Caminho 108",
    d: "M203.358,262.267l-5.415,5.286,1.275,2.835-2.835,2.769-7.143-16.7,3.235-3.159,16.5,7.563-2.818,2.749Zm-6.905,2.375,4.018-3.918-7.427-3.608,3.41,7.53Z",
    transform: "translate(-147.508 -214.152)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_109",
    "data-name": "Caminho 109",
    d: "M273.394,187.951a7.936,7.936,0,0,1,7.926-.258l-1.794,2.9a4.811,4.811,0,0,0-4.543.139,5.569,5.569,0,0,0,5.518,9.661,5.734,5.734,0,0,0,2.534-2.94l-1.021-1.787-3.925,2.243-1.536-2.689,7.011-4.008,3.211,5.623a9.392,9.392,0,0,1-4.675,6.357c-4.3,2.458-9.542,1.474-12.188-3.155-2.66-4.652-.819-9.624,3.482-12.079Z",
    transform: "translate(-200.697 -169.594)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_110",
    "data-name": "Caminho 110",
    d: "M337.241,170.461l-2.478.915,2.1,5.693-3.383,1.252-5.874-15.885,7.431-2.749c3.311-1.226,6.135.195,7.229,3.149a4.86,4.86,0,0,1-1.735,6l5.808,4.728L342.461,175l-5.223-4.54Zm-1.622-7.685-3.548,1.312,1.622,4.381,3.548-1.312a2.345,2.345,0,1,0-1.619-4.384Z",
    transform: "translate(-240.161 -151.173)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_111",
    "data-name": "Caminho 111",
    d: "M401.612,141.386a8.762,8.762,0,1,1-7.064,10.245A8.509,8.509,0,0,1,401.612,141.386Zm.591,3.142c-3.069.578-4.6,3.3-4.011,6.416.582,3.1,3,5.095,6.073,4.516s4.619-3.324,4.037-6.42c-.588-3.119-3.026-5.088-6.1-4.51Z",
    transform: "translate(-284.867 -139.093)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_112",
    "data-name": "Caminho 112",
    d: "M469.77,134.972l3.657-.04.106,10.057c.026,2.362,1.338,3.971,3.978,3.945,2.59-.026,3.869-1.665,3.842-4.027l-.106-10.057,3.658-.04.106,10.156c.043,4.216-2.339,7.11-7.467,7.163-5.181.053-7.622-2.815-7.665-6.981l-.106-10.183Z",
    transform: "translate(-335.353 -134.81)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_113",
    "data-name": "Caminho 113",
    d: "M539.4,137.21l7.83,1.206a5.284,5.284,0,0,1,4.791,6.261c-.449,2.911-2.832,5.038-6.446,4.48l-4.265-.657-.922,6-3.565-.548L539.4,137.21Zm6.885,4.193-3.79-.585-.71,4.619,3.79.585a2.34,2.34,0,1,0,.71-4.616Z",
    transform: "translate(-380.25 -136.417)",
    fill: "#b1965e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_114",
    "data-name": "Caminho 114",
    d: "M114.9,728.828l-8.821-3.406,3.41-8.821,8.828,3.406-3.413,8.821Zm-5.666-4.8,4.272,1.652,1.655-4.275-4.279-1.652-1.649,4.279Z",
    transform: "translate(-28.894 -405.594)",
    fill: "#b3965f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEssentia21AnosEsp);
export default __webpack_public_path__ + "static/media/logo_essentia_21_anos_ESP.44d9e858077f57b13b2a3cc75b6d0103.svg";
export { ForwardRef as ReactComponent };